module.exports = __webpack_public_path__ + "img/Skirt-Front-B3-Da-Fb-Ge-Hc-Ia.fc7c64d2.png";